export const styles = () => ({
  contentWrapper: { backgroundColor: '#d5d6d8', padding: 25 },
});
